import { reducerWithInitialState } from 'typescript-fsa-reducers'

import MediaInputState from '../states/MediaInputState'
import { MediaInput } from '../actions'

export const initialState: MediaInputState = {
  photo: undefined
}

export default reducerWithInitialState(initialState)
  .case(MediaInput.selectPhoto, (state, photo) => ({
    ...state,
    photo
  }))
  .case(MediaInput.clearPhoto, state => ({
    ...state,
    photo: undefined
  }))
  .case(MediaInput.uploadPhoto.started, state => ({
    ...state,
    photo: undefined
  }))
  .build()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/mediaInput.ts